import { useState, useEffect } from 'react';
import React from 'react';
import moment from 'moment';
import { encryptStorage } from '../constant';
import { useNavigate } from 'react-router-dom';
import { getOffboardingDataUser } from '../service/DirectorAPI';
import { getReportingEmpId } from '../service/DirectorAPI';

import './Offboardcss/CSS/Concern-form.css';
import './Offboardcss/CSS/feedback.css';
import './Offboardcss/CSS/Goal-form.css';
import './Offboardcss/CSS/leave_request.css';
import './Offboardcss/CSS/leave-form.css';
import './Offboardcss/CSS/Leaveview.css';
import './Offboardcss/CSS/Offboarding-popup.css';
import './Offboardcss/CSS/Transition-plan.css';

/**
 * PC_OF_07 - PC_OF_08
 * Create a export function with state variable to store the response with initially as null value
 * and the method for changing the values of useState() property.
 */
export default function OffboardingGrid(props) {
    const [offboadGridData, setoffboadGridData] = useState([]);
    const [empId, setempId] = useState(props.empId);
    const [loggedInempId, setloggedInempId] = useState(encryptStorage.getItem('employeeId'));
    const [role, setrole] = useState(encryptStorage.getItem('role'));
    const navigate = useNavigate();

    let search = window.location.search;
    let teamMem = new URLSearchParams(search).get('IsTeamMember');
    let isProfile = props.isProfile;

    /**
     * PC_OF_10
     * Inside the useEffect method the initial method that need to be get triggered
     */

    useEffect(() => {
        setempId(props.empId);
        loadGridPage(empId);
    }, []);

    /**
     * PC_OF_11
     * Make an await call and pass the client id
     * we need to set a endpoint , requestType in client function inside the api.js.
     * endpoint will be like passing the parameter and also setting the datatype to the parameters,
     * requestType will be setting the route 'POST' to the client method.
     **/
    const loadGridPage = async (empId) => {
        let validReportTo = false;
        try {
            let empdata = {
                empID: empId,
            };
            let data = await getOffboardingDataUser(empdata);

            switch (encryptStorage.getItem('groupid')) {
                case '1':
                    {
                        validReportTo = true;
                        break;
                    }
                case '2':
                    {
                        if (encryptStorage.getItem("employeeId") == data.data.ResponseData[0].emp_id) {
                                validReportTo = true;

                        }
                        else {

                            let request = {
                                login_id: encryptStorage.getItem('employeeId'),
                            };
                             getReportingEmpId(request).then((respdata)=>{

                            for (let i = 0; i < respdata.data.ResponseData?.length; i++) {
                                if (respdata.data.ResponseData[i]?.emp_id === data.data.ResponseData[0].emp_id) {
                                    validReportTo = true;
                                }
                                //
                            }})
                        }
                        break;
                    }
                case '3':
                    {
                        if (data.data.ResponseData[0].emp_id == encryptStorage.getItem("employeeId"))
                            validReportTo = true;
                        break
                    }
                default:
                    {
                        navigate('*')
                        break;
                    }
                    
            }

            setoffboadGridData(data.data.ResponseData[0]);
        } catch (error) {}
    };

    /**
     * PC_OF_15
     * To bind the grid body dynamically
     **/

    const offboardingGridBodyData = () => {
        try {
            if (offboadGridData.length == 0) {
                return (
                    <tr>
                        <td colspan="10" className="accord-content1">
                            <div className="row justify-content-center">
                                <img src="/Images/nodatafound.png" alt="nodatafound" className="nofeedbackimg-sty nodatafound" />
                                <h2 className="tt-bold font-15 text-center">No Records Found</h2>
                            </div>
                        </td>
                    </tr>
                );
            } else {
                return offboadGridData.map((obj, index) => {
                    let AppliedDate = moment(obj.created_at).format('MMM DD, YYYY');
                    let lastDate = moment(obj.last_working_date).format('MMM DD, YYYY');
                    var tipCount;
                    var commentsTrans;
                    if (obj.transitionplan !== null) {
                        if (obj.transitionplan.length > 15) {
                            commentsTrans = obj.transitionplan.substring(0, 13);
                            commentsTrans = commentsTrans + '...';
                            tipCount = 1;
                        } else {
                            commentsTrans = obj.transitionplan;
                            tipCount = 0;
                        }
                    }
                    return (
                        <tr className="hive-table-data">
                            {obj.transitionplan == null ? (
                                <td>-</td>
                            ) : (
                                <td>
                                    <a
                                        style={{ textDecoration: 'none', cursor: 'pointer !important' }}
                                        href={
                                            teamMem == 'true'
                                                ? `/offboardingForm?emp_id=${obj.emp_id}&offboarding_Id=${obj.offboarding_id}&mode=Edit&IsTeamMember=true`
                                                : isProfile == true
                                                ? `/offboardingForm?emp_id=${obj.emp_id}&offboarding_Id=${obj.offboarding_id}&mode=Edit&IsProfile=true`
                                                : `/offboardingForm?emp_id=${obj.emp_id}&offboarding_Id=${obj.offboarding_id}&mode=Edit`
                                        }
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title={tipCount == 1 ? obj.transitionplan : ''}
                                    >
                                        {commentsTrans}
                                    </a>
                                </td>
                            )}
                            <td>{AppliedDate}</td>
                            <td>{lastDate == 'Invalid date' ? '-' : lastDate}</td>
                            <td>{obj.resportstoname == null ? '-' : obj.resportstoname}</td>
                            <td>{obj.hrname == null ? '-' : obj.hrname}</td>

                            {obj.transitionstatus == null ? <td>-</td> : null}
                            {obj.transitionstatus == 'Completed' ? <td style={{ color: '#1EB131' }}>{obj.transitionstatus}</td> : null}
                            {obj.transitionstatus == 'In Progress' ? <td style={{ color: '#4466D8' }}>{obj.transitionstatus}</td> : null}
                            {obj.transitionstatus == 'Yet To Start' ? <td style={{ color: '#FF5151' }}>{obj.transitionstatus}</td> : null}

                            {obj.status == 'Completed' ? <td style={{ color: '#1EB131' }}>Approved</td> : null}
                            {obj.status == 'In Progress' ? <td style={{ color: '#4466D8' }}>{obj.status}</td> : null}
                            {obj.status == 'Yet To Start' ? <td style={{ color: '#FF5151' }}>{obj.status}</td> : null}
                            {(role == 'Hr Manager' || role == 'Hr') && empId != loggedInempId && props.EmployeeStatus != 'Inactive' ? (
                                <td className="text-center">
                                    <a
                                        href={
                                            teamMem == 'true'
                                                ? `/offboardingForm?offboarding_Id=${obj.offboarding_id}&mode=Trans&IsTeamMember=true&emp_id=${obj.emp_id}`
                                                : `/offboardingForm?offboarding_Id=${obj.offboarding_id}&mode=Trans&emp_id=${obj.emp_id}`
                                        }
                                        className="text-decoration-none mx-2"
                                    >
                                        <img src="/Images/profile-edit-icon-enable.svg" title="Edit" alt="Edit Icon" />
                                    </a>
                                </td>
                            ) : (
                                <td className="text-center">
                                    {' '}
                                    <a className="text-decoration-none mx-2">
                                        {' '}
                                        <img src="/Images/edit-disabled.svg" alt="icon" />
                                    </a>
                                </td>
                            )}
                        </tr>
                    );
                });
            }
        } catch (error) {}
    };

    return (
        <div className="mt-5">
            <div className="col-md-12 my-3 d-flex align-items-center ">
                <h2 className="font-15 tt-bold concern-form-label">Offboarding</h2>
            </div>
            <div className="col-md-12">
                <div className="table-responsive">
                    <table className="table bg-white hive-grid table-borderless profile-regular-font">
                        <thead>
                            <tr>
                                <th className="hive-table-head bold-text font-14">
                                    Transition Plan<span className="ps-2"></span>
                                </th>
                                <th className="hive-table-head bold-text font-14">
                                    Applied Date<span className="ps-2"></span>
                                </th>
                                <th className="hive-table-head bold-text font-14">
                                    Offboard Date<span className="ps-2"></span>
                                </th>
                                <th className="hive-table-head bold-text font-14">
                                    Manager in charge<span className="ps-2"></span>
                                </th>
                                <th className="hive-table-head bold-text font-14">
                                    HR in charge<span className="ps-2"></span>
                                </th>
                                <th className="hive-table-head bold-text font-14">
                                    Transition Status<span className="ps-2"></span>
                                </th>
                                <th className="hive-table-head bold-text font-14">Offboarding Status</th>
                                <th className="hive-table-head text-center bold-text font-14">Action</th>
                            </tr>
                        </thead>
                        <tbody>{offboardingGridBodyData()}</tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}
